type typeValues = "string" | "number" | "short-date" | "date" | "currency" | "percent";

class ColumnsModel {
  columnKey!: string;
  columnName!: string;
  /** 'image' = miniatura (el valor es la URL ya firmada). */
  type?: string;
}

export class CustomTableModel {
  columns: ColumnsModel[];
  data: Object[];

   constructor(columns: ColumnsModel[], data: Object[]){
    this.columns = columns;
    this.data = data;
  }
}

export class TableStructureModel {
  columnKey: string;
  columnName: string;
  type: typeValues
  

  // Constructor para inicializar los valores
  constructor(columnKey: string, columnName: string, type: typeValues) {
      this.columnKey = columnKey;
      this.columnName = columnName;
      this.type = type;
  }
}
  

export class TableMenuModel {
  icon: string;
  color: string;
  display: string;
  action: string;
  

  // Constructor para inicializar los valores
  constructor(color: string, display: string, action: string, icon: string) {
      this.color = color;
      this.display = display;
      this.action = action;
      this.icon = icon;
  }
}


export class EventEmitedModel {
  action!: string;
  item: any;
}